/**
 * Ticket System Firebase Configuration
 * 
 * 環境別設定（開発/本番）
 * 環境変数 FIREBASE_ENV で切り替え（デフォルト: dev）
 */

// Firebase設定（共通）
export const firebaseConfigTickets = {
  apiKey: "AIzaSyB3PubtL8qd3YwXOQpl0cJEqGBs6wAqlFg",
  authDomain: "ticketsystem-4bc88.firebaseapp.com",
  databaseURL: "https://ticketsystem-4bc88-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ticketsystem-4bc88",
  storageBucket: "ticketsystem-4bc88.firebasestorage.app",
  messagingSenderId: "961095544705",
  appId: "1:961095544705:web:fb05eef6906f73d5f78280"
};

// Firestoreデータベース名（環境別）
const env = process.env.REACT_APP_ENV || process.env.FIREBASE_ENV || 'dev';
export const firestoreDatabaseId = env === 'prd' ? 'prd-firebase-store' : 'dev-firebase-store';

/**
 * Google OAuth 設定
 * 
 * PC側（Electron）:
 * - Desktop OAuth 用のクライアントID・シークレットを設定
 * 
 * モバイル側（React Native Web）:
 * - Web OAuth 用のクライアントID
 */
export const googleOAuthConfig = {
  // Electron / Desktop
  desktop: {
    clientId: "YOUR_DESKTOP_CLIENT_ID.apps.googleusercontent.com",
    clientSecret: "YOUR_DESKTOP_CLIENT_SECRET"
  },
  
  // React Native / Web
  web: {
    clientId: "YOUR_WEB_CLIENT_ID.apps.googleusercontent.com"
  }
};

/**
 * RevenueCat 設定
 * 
 * https://www.revenuecat.com で無料登録
 * 課金処理を担当（Apple App Store, Google Play Store 対応）
 */
const revenuecatDevConfig = {
  apiKey: "test_QyfOzSVNRVQTWzuHeGWLUMBeoxZ",
  
  // RevenueCat Dashboard で定義したプロダクト
  products: {
    basic: {
      id: 'ticket_basic_1000_30d',  // 1000 QRコード / 30日 / 1000円
      name: 'Basic Plan',
      description: '1000 QRコード / 30日',
      price: 1000,
      currency: 'JPY',
      entitlementId: 'premium'
    },
    standard: {
      id: 'ticket_standard_10000_30d',  // 10000 QRコード / 30日 / 10000円
      name: 'Standard Plan',
      description: '10000 QRコード / 30日',
      price: 10000,
      currency: 'JPY',
      entitlementId: 'premium'
    }
  },
  
  // iPhone App Store / Google Play Store用のプロダクトID
  storeProducts: {
    ios: {
      basic: 'ticket_basic_ios_dev',
      standard: 'ticket_standard_ios_dev'
    },
    android: {
      basic: 'ticket_basic_android_dev',
      standard: 'ticket_standard_android_dev'
    }
  }
};

const revenuecatPrdConfig = {
  apiKey: "YOUR_PRD_REVENUECAT_API_KEY",
  
  products: {
    basic: {
      id: 'ticket_basic_1000_30d',
      name: 'Basic Plan',
      description: '1000 QRコード / 30日',
      price: 1000,
      currency: 'JPY',
      entitlementId: 'premium'
    },
    standard: {
      id: 'ticket_standard_10000_30d',
      name: 'Standard Plan',
      description: '10000 QRコード / 30日',
      price: 10000,
      currency: 'JPY',
      entitlementId: 'premium'
    }
  },
  
  storeProducts: {
    ios: {
      basic: 'ticket_basic_ios',
      standard: 'ticket_standard_ios'
    },
    android: {
      basic: 'ticket_basic_android',
      standard: 'ticket_standard_android'
    }
  }
};

export const revenuecatConfig = env === 'prd' ? revenuecatPrdConfig : revenuecatDevConfig;
